export default __webpack_public_path__ + "static/media/hero-burger-640w.9e4b5c09.jpg";